import { render, staticRenderFns } from "./RejectedCard.vue?vue&type=template&id=e5b8fbc0&scoped=true&lang=true&"
import script from "./RejectedCard.vue?vue&type=script&lang=js&"
export * from "./RejectedCard.vue?vue&type=script&lang=js&"
import style0 from "./RejectedCard.vue?vue&type=style&index=0&id=e5b8fbc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b8fbc0",
  null
  
)

export default component.exports